import { Button, DialogContent, DialogFooter, DialogHeader, DialogRoot, DialogTitle, Input } from '@ibsys/kit';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

type CreateReportDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string) => void;
  isPending: boolean;
};

export const CreateReportDialog: FC<CreateReportDialogProps> = ({ isOpen, onClose, onSubmit, isPending }) => {
  const { t } = useTranslation(['common', 'expertReport']);
  const [name, setName] = useState('');

  const handleSubmit = () => {
    const trimmedName = name.trim();
    if (!trimmedName) return;
    onSubmit(trimmedName);
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setName('');
      onClose();
    }
  };

  return (
    <DialogRoot open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('expertReport:createReport')}</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <Input
            label={t('expertReport:reportName')}
            placeholder={t('expertReport:enterName')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isPending}>
            {t('common:cancel')}
          </Button>
          <Button onClick={handleSubmit} disabled={isPending || !name.trim()}>
            {t('common:add')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};
